import React, { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import getDaysInMonth from 'date-fns/fp/getDaysInMonth'

import { getFirstDayOfMonth } from 'aem-libs-react-ts/src/utils/DateUtils'

import cs from '../i18n/cs.json'
import en from '../i18n/en.json'

import { Mode } from '../enums'
import ModeElement from './ModeElements'
import { DisableDates } from '../Datepicker'

interface IProps {
  selectedDate: Date
  showCurrentDay?: boolean
  disableDates?: DisableDates
  disableInModes: Mode[]
  onSelectDay?: (day: number) => void
}

const ModeDays = (props: IProps) => {
  const { t, i18n } = useTranslation('ModeDays')
  i18n.addResourceBundle('cs', 'ModeDays', cs)
  i18n.addResourceBundle('en', 'ModeDays', en)

  const firstDayOfMonth = getFirstDayOfMonth(props.selectedDate)

  const daysInMonth = getDaysInMonth(props.selectedDate)

  const days: number[] = []
  for (let i = 1; i <= daysInMonth; i++) {
    days.push(i)
  }

  const totalSlots: ReactElement[] = []
  for (let i = 0; i < firstDayOfMonth; i++) {
    totalSlots.push(
      <td key={i} className='cs-rdatepicker__table-cell--empty'>
        {''}
      </td>
    )
  }

  return (
    <div className='cs-rdatepicker__mode-content'>
      <table>
        <thead>
          <tr>
            <td>{t('MONDAY_SH')}</td>
            <td>{t('TUESDAY_SH')}</td>
            <td>{t('WEDNESDAY_SH')}</td>
            <td>{t('THURSDAY_SH')}</td>
            <td>{t('FRIDAY_SH')}</td>
            <td>{t('SATURDAY_SH')}</td>
            <td>{t('SUNDAY_SH')}</td>
          </tr>
        </thead>
        <ModeElement
          mode={Mode.Day}
          values={days}
          columns={7}
          selectedDate={props.selectedDate}
          elements={totalSlots}
          disableDates={props.disableDates}
          disableFull={props.disableInModes.indexOf(Mode.Day) !== -1}
          onClick={(index: number) => props.onSelectDay && props.onSelectDay(days[index])}
        />
      </table>
    </div>
  )
}

export default ModeDays
